import { ThemeContext } from '@/theme/ThemeProvider';
import { useIsMobile } from '@/utils/CalVW';
import { useContext } from 'react';
import styled from 'styled-components';
import MInActiveSvg from './MInActiveSvg';

const InActiveSvg = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const fill = isDarkMode ? '#9897A0' : '#BDBDBD';
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MInActiveSvg />;
  }

  return (
    <>
      <FirstLayer
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M85.3602 14.6435C65.8397 -4.88248 34.1908 -4.88248 14.6704 14.6435C13.2724 16.0419 11.9557 17.5215 10.7305 19.0743C10.3262 19.613 10.4339 20.3772 10.9723 20.7816C11.4925 21.1719 12.228 21.0865 12.6425 20.5845C13.5508 19.4321 14.518 18.3183 15.5421 17.2411L18.8317 20.5316C19.297 20.9971 20.0488 21.0093 20.5283 20.5581C21.0201 20.0642 21.018 19.2674 20.5243 18.7756C20.5222 18.7735 20.5202 18.7715 20.5182 18.7695L17.2651 15.5155C25.7808 7.38149 37.0253 2.72305 48.7961 2.45477V7.0563C48.786 7.72702 49.3082 8.28798 49.9787 8.3266C50.6513 8.34692 51.2141 7.81848 51.2344 7.14573C51.2344 7.13353 51.2344 7.11931 51.2344 7.10711V2.45273C63.0052 2.72102 74.2498 7.38149 82.7634 15.5175L79.5104 18.7715C79.0146 19.2593 79.0085 20.0581 79.4961 20.554C79.4961 20.554 79.5002 20.5581 79.5022 20.5601C79.9818 21.0113 80.7336 20.9991 81.1989 20.5337L84.4885 17.2431C92.6222 25.7571 97.2793 37.0069 97.5475 48.7811H92.9453C92.2748 48.7709 91.714 49.2933 91.6753 49.964C91.655 50.6367 92.1833 51.1997 92.8559 51.22C92.8681 51.22 92.8823 51.22 92.8945 51.22H97.5475C97.2793 62.9942 92.6222 74.2419 84.4885 82.758L81.2354 79.504C80.7681 79.0223 80.0041 78.9939 79.5022 79.441C79.0125 79.9024 78.9882 80.6747 79.4494 81.1646C79.4575 81.1727 79.4657 81.1828 79.4758 81.191L82.7655 84.4816C74.2518 92.6176 63.0073 97.2781 51.2365 97.5443V92.9428C51.2466 92.2721 50.7244 91.7111 50.0559 91.6725C49.3834 91.6522 48.8205 92.1806 48.8002 92.8533C48.8002 92.8655 48.8002 92.8798 48.8002 92.892V97.5463C37.0294 97.2781 25.7849 92.6176 17.2712 84.4816L20.5243 81.2276C21.0058 80.7601 21.0343 79.9959 20.5873 79.4939C20.126 79.004 19.3539 78.9796 18.8642 79.441C18.8541 79.4491 18.8459 79.4593 18.8378 79.4674L15.5481 82.758C7.41445 74.244 2.75733 62.9942 2.48912 51.22H7.09138C7.7619 51.2302 8.32271 50.7079 8.36131 50.0392C8.38163 49.3664 7.85334 48.8034 7.18078 48.7831C7.16859 48.7831 7.15437 48.7831 7.14217 48.7831H2.48303C2.64355 41.9093 4.30158 35.1513 7.33927 28.9827C7.63796 28.379 7.39007 27.6473 6.78456 27.3486C6.18109 27.0498 5.4496 27.2978 5.15091 27.9034C-7.04456 52.6855 3.15152 82.6625 27.9265 94.8614C47.13 104.319 70.2225 100.497 85.3602 85.3576C104.881 65.8315 104.881 34.1736 85.3602 14.6476V14.6435Z"
          fill={fill}
        />
      </FirstLayer>

      <SecondLayer
        width="82"
        height="82"
        viewBox="0 0 82 82"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M41.0149 81.5466C63.3679 81.5466 81.5514 63.3579 81.5514 40.9986C81.5514 18.6393 63.3679 0.450684 41.0149 0.450684C18.662 0.450684 0.478516 18.6414 0.478516 40.9986C0.478516 63.3559 18.664 81.5466 41.0149 81.5466ZM41.0149 2.88966C62.0228 2.88966 79.1131 19.9848 79.1131 40.9986C79.1131 62.0124 62.0228 79.1076 41.0149 79.1076C20.0071 79.1076 2.9168 62.0124 2.9168 40.9986C2.9168 19.9848 20.0071 2.88966 41.0149 2.88966Z"
          fill={fill}
        />
      </SecondLayer>

      <ThirdLayer
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.095 69.8438C42.5111 70.0755 50.7261 67.2361 57.2038 61.8561C57.7239 61.4273 57.7971 60.657 57.3684 60.1367C57.3054 60.0594 57.2342 59.9924 57.153 59.9334C56.7039 59.6001 56.0842 59.6163 55.6534 59.9741C49.7426 64.8845 42.2713 67.5247 34.5887 67.415C16.9498 67.1873 2.63707 52.7039 2.60659 35.0599C2.57408 17.1436 17.1489 2.56059 35.0581 2.58295C52.7356 2.60531 67.2414 16.981 67.4242 34.6636C67.4974 41.0354 65.6809 47.2873 62.2022 52.6267C61.8406 53.1937 62.0072 53.9478 62.5741 54.3116C63.1288 54.6652 63.8643 54.5148 64.2362 53.9722C67.981 48.2304 69.9377 41.5049 69.8605 34.6494C69.6695 15.538 53.9344 0.0443809 34.8285 0.146005C15.5376 0.247629 -0.0958375 16.1091 0.170342 35.4908C0.420265 53.7404 15.8526 69.3743 34.095 69.8478V69.8438Z"
          fill={fill}
        />
      </ThirdLayer>
    </>
  );
};

export default InActiveSvg;

const FirstLayer = styled.svg`
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
`;

const SecondLayer = styled.svg`
  position: absolute;
  top: 9.5%;
  left: 9.88%;
`;

const ThirdLayer = styled.svg`
  position: absolute;
  left: 15.84%;
  top: 15.44%;
`;
